import React, {  } from "react";
import type * as controls from "../PhoenixFormsV4.Controls";
import { SelectionControlGroup } from "react-md";
import PNXLabel from "./PNXLabel";
import { MSelect } from "components/Shared";


interface ReadOnlyProps {
  controlProps: controls.ListFormControl;
}
interface Props extends ReadOnlyProps {  
  updateValue: (newValue: string) => void;
  onControlBlur: () => void;
};

const PhoenixSelect1 = ({
  controlProps,
  updateValue,
  onControlBlur,
} : Props) => {

  const appearance = controlProps.appearance ?? "full";
  const id = `select1-${controlProps.id}`;

  const getSelectedOption = () => { // for the react-selct controls
    if (!controlProps.value) return null;

    let valueOption = null;

    const options = controlProps.items.filter(i => i.value === controlProps.value);
    if (options.length) {
      valueOption = options[0];
    }
    else if (appearance === "phoenix:combo") { // combo box can have a created option
      valueOption = { label: controlProps.value, value: controlProps.value };
    }

    return valueOption;
  };

  switch (appearance) {
    case "full":
      return <SelectionControlGroup
        id={id}
        name={id}
        type="radio"
        label={<PNXLabel helpTopicId={controlProps.topicId}>{controlProps.label}</PNXLabel>}
        value={controlProps.value ?? ""}
        controls={controlProps.items}
        onChange={(value) => { updateValue(value); }}
        onBlur={() => onControlBlur()}
      />
    case "compact":
      return (
        <div>
          <PNXLabel helpTopicId={controlProps.topicId}>{controlProps.label}</PNXLabel>
          <MSelect
            value={getSelectedOption()}
            onChange={option => updateValue(option?.value ?? "")}
            onBlur={() => onControlBlur()}
            options={controlProps.items}
            placeholder="Select..."
            isClearable
          />
        </div>
      );
    case "minimal": 
      return (
        <div>
          <PNXLabel helpTopicId={controlProps.topicId}>{controlProps.label}</PNXLabel>
          <MSelect
            defaultValue={getSelectedOption()}
            onChange={option => updateValue(option?.value ?? "")}
            onBlur={() => onControlBlur()}
            options={controlProps.items}
            placeholder="Search or Enter Value..."
            isClearable
          />
        </div>
      );
    case "phoenix:combo": 
      return (
        <div>
          <PNXLabel helpTopicId={controlProps.topicId}>{controlProps.label}</PNXLabel>
          <MSelect
            defaultValue={getSelectedOption()}
            onChange={option => updateValue(option?.value ?? "")}
            onBlur={() => onControlBlur()}
            options={controlProps.items}
            placeholder="Search or Enter Value..."
            isClearable
            creatable
          />
        </div>
      );
  }
};

export const willPhoenixSelect1ReadOnlyRender = (controlProps: controls.ListFormControl) => !!controlProps.value;

export const PhoenixSelect1ReadOnly = ({
  controlProps,
} : ReadOnlyProps) => {

  if (!controlProps.value) return null;

  // map value to item label if present
  const option = controlProps.items.filter(item => item.value === controlProps.value);
  const mappedValue = option.length ? option[0].label : controlProps.value;    

  return (
    <div>
      <PNXLabel>{controlProps.label}</PNXLabel>
      <div>{mappedValue}</div>
    </div>
  );
};


export default PhoenixSelect1;